import actionTypes from 'constants/actionTypes'
import single from './single'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import reduce from 'lodash/reduce'
import { isHardFail } from 'lib/action'

interface EdgeInput {
  id?: string
  [key: string]: unknown
}

type EdgesAllState = Record<string, ReturnType<typeof single>>

interface EdgesAllAction {
  type?: string
  payload?: {
    id?: string
    ids?: string[]
    data?: {
      id?: string
      ids?: string[]
      edges?: EdgeInput[]
    }
  }
  previousPayload?: {
    id?: string
    ids?: string[]
  }
}


const all = (state: EdgesAllState = {}, action: EdgesAllAction): EdgesAllState => {
  const actionType = action.type ?? ''
  switch (true) {
    case actionType === actionTypes.EDGES.ONE.CREATE.FAIL: {
      const id = action.previousPayload?.id
      if (!id) return state
      if (isHardFail(action)) {
        const updated = cloneDeep(state)
        delete updated[id]
        return updated
      }
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.EDGES.ONE.CREATE.REQUEST,
      actionTypes.EDGES.ONE.CREATE.RECEIVE,
      actionTypes.EDGES.ONE.CREATE.NOTIFY,
      actionTypes.EDGES.ONE.START_EDITING,
      actionTypes.EDGES.ONE.STOP_EDITING,
      actionTypes.EDGES.ONE.EDIT.REQUEST,
      actionTypes.EDGES.ONE.EDIT.RECEIVE,
      actionTypes.EDGES.ONE.EDIT.NOTIFY,
      actionTypes.EDGES.ONE.EDIT.FAIL,
      actionTypes.EDGES.ONE.DELETE.REQUEST,
      actionTypes.EDGES.ONE.DELETE.RECEIVE,
      actionTypes.EDGES.ONE.DELETE.NOTIFY,
      actionTypes.EDGES.ONE.DELETE.FAIL
    ].includes(actionType): {
      const id = action.payload?.id || action.payload?.data?.id || action.previousPayload?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.EDGES.MULTI.DELETE.REQUEST,
      actionTypes.EDGES.MULTI.DELETE.RECEIVE,
      actionTypes.EDGES.MULTI.DELETE.NOTIFY,
      actionTypes.EDGES.MULTI.DELETE.FAIL
    ].includes(actionType): {
      const ids = action.payload?.ids || action.payload?.data?.ids || action.previousPayload?.ids
      return reduce(ids ?? [], (es: EdgesAllState, id: string) => {
        return defaultsDeep(
          {
            [id]: single(state[id], action, { id })
          },
          es
        )
      }, state)
    }
    case actionType === actionTypes.GRAPH.GET_NEIGHBORHOOD.RECEIVE:
      return reduce(action.payload?.data?.edges ?? [], (es: EdgesAllState, edge: EdgeInput) => {
        const edgeId = edge.id
        if (!edgeId) return es
        return defaultsDeep(
          {
            [edgeId]: single(state[edgeId], action, edge)
          },
          es
        )
      }, state)
    default:
      return state
  }
}

export default all
